// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"319f59e9","379":"6b4e2ede","627":"3799f03f","691":"a8bdc266","900":"823bc728","918":"411dff79","938":"69c81228","966":"09979a19","971":"58cc413f"}[chunkId] + ".chunk.js";
};